<div mat-dialog-title class="d-flex justify-content-between align-items-center pt-2">
  <div class="prese_heading">
  <h2 class="m-0">Edit meeting info</h2>
  </div>
  <div class="prese_button">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  </div>

  <mat-dialog-content style="padding-top: 20px;">
   <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Online meeting link</mat-label>
        <input [(ngModel)]="online_session_link" matInput maxlength="400" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>App download (if there any) </mat-label>
        <textarea
          [(ngModel)]="online_session_app"
          [maxLength]="400"
          matInput
        ></textarea>
        <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Other session info</mat-label>
        <textarea
          [(ngModel)]="online_session_notes"
          [maxLength]="400"
          matInput
        ></textarea>
        <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
      </mat-form-field>
    </div>
    <p style="color: #888;">
            Add the detailed online meeting info with the link to join. Also include if there any mobile/desktop app needed, so your member have everything you need to go online with your service.
          </p>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
        (click)="onPost()"
    >
      Save
    </button>
  </mat-dialog-actions>